var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_c('processed-image',{staticClass:"attribution-image",attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"transforms":{ width: _vm.width, height: _vm.height }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }